import { AddonFooter, Flex, FlexProps } from '@bitrise/bitkit';
import React, { ReactNode, FunctionComponent } from 'react';
import PageContent from './PageContent';

interface Props extends FlexProps {
  children: ReactNode;
}

const PageBody: FunctionComponent<Props> = (props) => {
  const {
    alignChildren,
    alignChildrenHorizontal,
    alignChildrenVertical,
    backgroundColor = 'gray-1',
    children,
    ...rest
  } = props;

  return (
    <Flex {...rest} backgroundColor={backgroundColor} direction="vertical" grow>
      <PageContent
        alignChildren={alignChildren}
        alignChildrenHorizontal={alignChildrenHorizontal}
        alignChildrenVertical={alignChildrenVertical}
        direction="vertical"
        grow
        paddingVertical="x8"
      >
        {children}
      </PageContent>

      <Flex paddingVertical="x16">
        <AddonFooter addonName="Trace" />
      </Flex>
    </Flex>
  );
};

export default PageBody;
